import React from "react";
import removeImg from "../../assets/images/close.png";
import server from "../../api/server";
import Image from "next/future/image";

import { FormattedMessage } from "react-intl";

const FileUpload = ({ selectedFile, setSelectedFile, id = "" }) => {
  const fileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const { data } = await server.post("/upload", formData);

      setSelectedFile({
        preview: e.target.file,
        path: data.data.file.path,
      });
    }
  };

  const removeSelectedImage = () => {
    setSelectedFile("");
  };
  return (
    <div className="image-uploader image-contain">
      <div
        className="form-group"
        data-aos="fade-up"
        data-aos-duration="300"
        data-aos-delay="400"
      >
        <input type="file" className="form-control " onChange={fileChange} aria-label="Image Upload" />
      </div>
    </div>
  );
};

export default FileUpload;
